import * as React from "react";
import { forwardRef } from "react";
const SvgCompare = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 30, height: 6, viewBox: "0 0 30 6", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("g", { fill: "none", fillRule: "evenodd" }, /* @__PURE__ */ React.createElement("rect", { width: 30, height: 2, y: 2, fill: "#589FFB", rx: 1 }), /* @__PURE__ */ React.createElement("circle", { cx: 15, cy: 3, r: 3, fill: "#FFF", stroke: "#589FFB" })));
const ForwardRef = forwardRef(SvgCompare);
export { ForwardRef as ReactComponent };
